<template>
  <SettingsPageLayout>
    <DetailForm
      v-if="loaded"
      title="Website"
      description="Use the following code snippet to add a widget of your Humaniz.io jobs to your own company website. This allows potential candidates to apply for your Humaniz.io jobs directly from your website. Take full advantage of your organic website traffic."
      action="Save"
      hideaction="true"
      hidecancel="true"
    >
      <TextAreaInput label="Code Snippet" :model-value="websiteLink" @update:model-value="websiteLink = $event" />
    </DetailForm>
  </SettingsPageLayout>
</template>

<script>
import SettingsPageLayout from '../../layouts/SettingsPageLayout/index.vue';
import DetailForm from '../../shared/DetailForm.vue';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';

export default {
  components: {
    SettingsPageLayout,
    DetailForm,
  },
  setup() {
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { loadingSpinnerStore };
  },
  data() {
    return {
      websiteLink: '',
      loaded: false,
    };
  },
  mounted() {
    this.getTeam();
  },
  methods: {
    getTeam() {
      const self = this;
      this.loadingSpinnerStore.showLoadingSpinner();
      fetch('/api/team')
        .then(response => {
          this.loadingSpinnerStore.hideLoadingSpinner();
          return response.json();
        })
        .then(data => {
          self.websiteLink = `<iframe src="https://www.humaniz.io/widget?company=${data.record.id}" width="100%" height="400" />`;
          self.loaded = true;
        });
    },
  },
};
</script>
